import React from "react";

import "./midea_viewer.css";
import { IP } from "../internalServer";

const MideaViewer = ({ closeMideaviewer, attachment }) => {
  const helper = (a) => {
    if (typeof a !== "string") return "";

    return IP + a.replace(/^\./, "");
  };

  return (
    <>
      <div className="midea_transprant_body">
        <div className="midea_container shadow">
          <img
            alt=""
            src="/images/cross-circle3.svg"
            className="midea_close_btn"
            onClick={(e) => closeMideaviewer(false)}
          />
          <iframe
            title="myFrame"
            src={helper(attachment)}
            className="iframe "
          />
        </div>
      </div>
    </>
  );
};

export default MideaViewer;
// import * as React from "react";
// import Stack from "@mui/material/Stack";
// import TextField from "@mui/material/TextField";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// const MideaViewer = () => {
//   const [value, setValue] = React.useState(new Date("2014-08-18T21:11:54"));

//   const handleChange = (newValue) => {
//     setValue(newValue);
//   };

//   return (
//     <>
//       <LocalizationProvider dateAdapter={AdapterDateFns}>
//         <Stack spacing={3}>
//           <TimePicker
//             label="Time"
//             value={value}
//             onChange={handleChange}
//             renderInput={(params) => <TextField {...params} />}
//           />
//         </Stack>
//       </LocalizationProvider>
//     </>
//   );
// };

// export default MideaViewer;
